import moment from "moment";
import ActionCellRender from "../../components/actionCellRender";
import { IconPencil } from "@tabler/icons-react";

export const QuotationTableSchema = (cellRender) => {
  return {
    showActionColumn: true,
    columns: [
      {
        field: "code",
        headerName: "Code",
        sortable: true,
        width: 150,
      },

      {
        field: "project.name",
        headerName: "Project",
        sortable: true,
        width: 200,
      },

      {
        field: "project.client.name",
        headerName: "Client",
        sortable: true,
        width: 200,
      },

      {
        field: "quoDate",
        headerName: "Quo Date",
        sortable: true,
        width: 150,
        cellRender: (col, data) => cellRender.Date(data.quoDate, "ll"),
      },
      {
        field: "createdBy",
        headerName: "Created By",
        sortable: true,
        width: 200,
        cellRender: (col, data) => cellRender.User(data.createdBy),
      },
      {
        field: "status",
        headerName: "Status",
        sortable: true,
        cellRender: (col, data) => cellRender.Status(data.status),
      },
      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
      },
    ],
    searchByTextField: true,
  };
};
